<template>
<v-avatar
	@mouseover="show = showUpload" @mouseleave="show = false"
	:tile="true"
	:size="150"
	color="grey lighten-4"
	class="wrap-avatar"
>
	<img v-if="avatar" :src="getAvatar(avatar)" alt="avatar">
	<img v-else src="../assets/temp_user_logo.png" alt="avatar">
	<div v-show="show" class="action">
		<button @click="upload">{{$t('common.upload')}}</button>
		<button @click="onDelete" v-if="avatar">{{$t('common.delete')}}</button>
		<UploadFile
			ref="uploader"
			:options="options"
			@progress-update="progressUpdate"
			@file-size-error="fileSizeError"
		/>
		<ConfirmDialog @accept="deleteAvatar" v-bind="propConfirmDialog" ref="confirm" class="confirm">
			{{$t('common.delete')}}
		</ConfirmDialog>
	</div>
</v-avatar>
</template>

<script>
import Vue from 'vue'
import UploadFile from './UploadFile'
import ConfirmDialog from './ConfirmDialog'
export default {
	components: {
		UploadFile,
		ConfirmDialog
	},
	data: vm => ({
		show: false,
		options: {
			button: {
				slot: 'activator',
				outline: true,
				text: 'Upload',
				dark: true
			},
			className: 'upload-avatar',
			url: Vue.http.options.root + vm.uploadPath
		},
		propConfirmDialog: {
			message: vm.$t('common.confirm_message_avatar'),
			title: vm.$t('workers.avatar'),
			btnProps: {
				color: 'green lighten-2',
				flat: true
			}
		}
	}),
	props: {
		avatar: {
			type: [String, Boolean],
			default: false
		},
		uploadPath: String,
		showUpload: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		getAvatar: name => Vue.http.options.root + '/files/' + name,
		upload() {
			this.$refs.uploader.chooseFile()
		},
		onDelete() {
			console.log(this.uploadPath)
			this.$refs.confirm.dialog = true
		},
		fileSizeError(fileNames) {
			console.error('Files blow are oversized: ', ...fileNames)
		},
		progressUpdate(fileInfoList) {
			console.log('upload speed（kb/s）：', fileInfoList[0].uploadSpeed)
			if (fileInfoList[0].type === 'success') {
				// do something
				console.log('success')
				const { filename } = JSON.parse(fileInfoList[0].response)
				this.$emit('setAvatar', filename)
			}
		},
		deleteAvatar() {
			this.$emit('delete')
		}
	}
}
</script>

<style scoped>
.action {
	position: absolute;
	background: #000;
	opacity: 0.5;
	width: 100%;
	height: 40%;
	bottom: 0;
	color: #fff;
}
button {
	width: 50%;
	height: 100%;
	border: 1px solid #fff;
}
.confirm {
	position: absolute !important;
	visibility: hidden !important;
}
</style>
